export default "/static/frontend/images/images/c51cc8588461bd290a07615355c68d80-apple.png";